import React, { useEffect } from "react";
import { storage } from "../../utils/helpers/storage";
import { useNavigate } from "react-router-dom";

const UnauthorizedComponent = () => {
  const { navigate } = useNavigate();

  useEffect(() => {
    if (storage.getKioskId()) {
      navigate("/kiosk");
    }
  }, []);

  return (
    <div className="unauthorized-container">
      <h1 className="unauthorized-title">Unauthorized Access</h1>
      <p>You do not have permission to access this page.</p>
      <p>Please contact your administrator.</p>
    </div>
  );
};

export default UnauthorizedComponent;
